export const numberOrUndefined = (value?: number | null): number | undefined => {
  if (value || value === 0) {
    return value
  }
  return undefined
}
